import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class CanonicalService {
  constructor(
    @Inject(DOCUMENT) private dom: any
  ) { }
  setIcon(shortcutIcon?: string){
    if(shortcutIcon !== undefined){
      const link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'icon');
      this.dom.head.appendChild(link);
      link.setAttribute('href', shortcutIcon);
    }
  }
  setShortcutIcon(shortcutIcon?: string){
    if(shortcutIcon !== undefined){
      const link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'shortcut icon');
      this.dom.head.appendChild(link);
      link.setAttribute('href', shortcutIcon);
    }
  }
  setAddressBarIcon(shortcutIcon?: string){
    if(shortcutIcon !== undefined){
      const link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'address baricon');
      this.dom.head.appendChild(link);
      link.setAttribute('href', shortcutIcon);
    }
  }
  setAppleTouchIcon(shortcutIcon?: string){
    if(shortcutIcon !== undefined){
      const link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'apple-touch-icon');
      this.dom.head.appendChild(link);
      link.setAttribute('href', shortcutIcon);
    }
  }
}